<template>
    <div class="activity-item-comments"">

        <div class="activity-item-comments__top">

            <!-- Toggle Responses -->
            <button @click="commentsOpen = !commentsOpen" class="activity-item-comments-toggle">
                <svg class="comment-new">
                    <use xlink:href="#comment-new"></use>
                </svg>
                <span v-if="commentsOpen">hide</span>
                {{ pluralize('Comments', currentReview.responses.length) }}
                <small v-show="currentReview.responses.length" v-text="`(${currentReview.responses.length})`"></small>
            </button>

            <ReviewLove :review="currentReview"></ReviewLove>
        </div>

        <div class="activity-item-comments__main">

            <!-- Leave Response -->
            <form :action="`/review/${currentReview.id}/response`" method="post" class="activity-item-comments__form" @submit.prevent="submit()">
                <img :src="authUser.profile_thumbnail" alt="" v-rjs="2" />
                <input type="text" ref="comment" placeholder="Enter comment" v-model="form.body"/>
                <button :disabled="(form.isSubmitted || form.body == '')">
                    Post
                </button>
            </form>

            <!-- Responses List -->
            <div v-for="response in currentReview.responses" :key="`review-response-${response.id}`" class="activity-item-comments__comment">
                <a :href="`/${response.user.username}`" class="comment-profile">
                    <img :src="response.user.profile_thumbnail" :alt="response.user.full_name" v-rjs="2" />
                </a>
                <div class="comment-header">
                    <h3>
                        <a :href="`/${response.user.username}`" class="person-hover-trigger" :data-user="response.user.username">
                            {{ response.user.full_name }}
                            <Verified :user="response.user"></Verified>
                        </a>
                        {{ diffForHumans(response.created_at) }}
                    </h3>
                </div>
                <ReviewBody :review="response"></ReviewBody>
                <div class="comment-extra">
                    <ReviewLove :review="response"></ReviewLove>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

import ReviewLove from './ReviewLove'
import ReviewBody from './ReviewBody'
import Helpers from '@/mixins/Helpers'
import Verified from '@/components/Verified'
import Form from '@/classes/Form'

export default {

    mixins: [Helpers],

    props: ['review'],

    components: {
        Verified,
        ReviewLove,
        ReviewBody,
    },

    data() {
        return {
            currentReview: this.review,
            commentsOpen: false,
            form: new Form({
                parent_id: this.review.id,
                recommendation_id: this.review.recommendation_id,
                published: true,
                body: '',
            })
        }
    },

    methods: {
        submit() {
            this.form.post(`/review/${this.currentReview.id}/response`)
                .then(response => {
                    this.currentReview = response.review
                    this.form.parent_id = this.currentReview.id
                    this.form.recommendation_id = this.currentReview.recommendation_id
                    this.form.published = true
                    this.form.body = ''
                })
                .catch(errors => {
                })
        }
    },

    computed:{
        authUser() {
            return config.user
        }
    }
}
</script>
